const CompanyBenefits = () => {
  return (
    <section className="bg-white py-12 sm:py-16 md:py-20 lg:py-16 overflow-x-hidden">
      <div className="container-content px-5 sm:px-6 lg:px-[15px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center gap-x-8 lg:gap-x-12 gap-y-8 sm:gap-y-10 lg:gap-y-12">
          {/* Text Content */}
          <div className="lg:col-span-6 xl:col-span-5 order-2 lg:order-1">
            <div
              className="mb-5 sm:mb-6 animate__animated animate__fadeInUp"
              style={{ animationDelay: "0.1s" }}
            >
              <span className="font-body text-xs sm:text-sm uppercase tracking-[2px] text-text-medium font-medium">
                Empowering You: Discover Our Array of
              </span>
              <h2 className="font-display text-3xl sm:text-[36px] lg:text-[42px] font-bold text-brand-navy leading-tight mt-2">
                Comprehensive <br /> Company Benefits
              </h2>
            </div>

            <blockquote
              className="my-6 sm:my-8 animate__animated animate__fadeInUp"
              style={{ animationDelay: "0.3s" }}
            >
              <p className="font-display italic text-lg sm:text-xl text-text-medium leading-[1.8]">
                "Whenever you see a successful business, someone once made a courageous decision."
              </p>
              <footer className="mt-3 sm:mt-4 font-body text-sm font-semibold text-brand-navy not-italic">
                - Peter F. Drucker
              </footer>
            </blockquote>

            <div
              className="space-y-4 sm:space-y-6 text-text-dark text-sm sm:text-base leading-[1.7] animate__animated animate__fadeInUp"
              style={{ animationDelay: "0.5s" }}
            >
              <p>
                At IMMACULATE, we deliver on promises. Your decision to partner with us will only help raise the quality, productivity, and efficiency of your workforce.
              </p>
              <p>
                We strongly believe in offering innovative tools to evaluate your needs and provide the right manpower solutions. We ensure solutions based on industry insights to deliver the best possible outcomes. Benchmarking that can help you move ahead of your competition, industry-best response time to get you the manpower you need when you need it, and cost-effective solutions that fit your budget are our specialization.
              </p>
            </div>
          </div>

          {/* Image Content */}
          <div className="lg:col-span-6 xl:col-span-6 xl:col-start-7 order-1 lg:order-2">
            <div
              className="relative animate__animated animate__fadeInRight"
              style={{ animationDelay: "0.2s" }}
            >
              <img
                src="/assest/Comprehensive-Company-Benefits-Image.jpg"
                alt="Comprehensive Company Benefits - IMMACULATE workforce solutions and benefits."
                className="rounded-lg object-cover w-full h-auto shadow-[0_5px_25px_rgba(0,0,0,0.08)]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyBenefits;